<template>
  <form method="post"
        :action="action"
        @submit.prevent="onSubmit"
        @keydown="form.errors.clear($event.target.name)">
    <div class="row">
      <div class="col-12">
        <div class="form-group my-input-item">
          <input type="text"
                 name="name"
                 class="form-control my-input-form my-input-form-grey"
                 placeholder="ФИО"
                 v-model="form.name"
          >
          <span class="help is-danger text-danger"
                v-if="form.errors.has('name')"
                v-text="form.errors.get('name')">
            </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group my-input-item">
          <input type="text"
                 name="date"
                 class="form-control my-input-form my-input-form-grey"
                 placeholder="Дата рождения"
                 v-model="form.date_born"
          >
          <span class="help is-danger text-danger"
                v-if="form.errors.has('dateBorn')"
                v-text="form.errors.get('dateBorn')">
            </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group my-input-item">
          <input type="text"
                 name="city"
                 class="form-control my-input-form my-input-form-grey"
                 placeholder="Город проживания"
                 v-model="form.city"
          >
          <span class="help is-danger text-danger"
                v-if="form.errors.has('city')"
                v-text="form.errors.get('city')">
            </span>
        </div>
      </div>

      <div class="col-6">
        <div class="form-group my-input-item">
          <input type="text"
                 name="phone"
                 class="form-control my-input-form my-input-form-grey mobilephone-input-mask"
                 :placeholder="Lang.get('common.phone')"
                 v-model="form.phone"
          >
          <span class="help is-danger text-danger"
                v-if="form.errors.has('phone')"
                v-text="form.errors.get('phone')">
            </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group my-input-item">
          <input type="text"
                 name="email"
                 class="form-control my-input-form my-input-form-grey"
                 placeholder="E-mail"
                 v-model="form.email"
          >
          <span class="help is-danger text-danger"
                v-if="form.errors.has('email')"
                v-text="form.errors.get('email')">
            </span>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group my-input-item">
          <input type="text"
                 name="university"
                 class="form-control my-input-form my-input-form-grey"
                 placeholder="ВУЗ (полное наименование, город)"
                 v-model="form.university"
          >
          <span class="help is-danger text-danger"
                v-if="form.errors.has('university')"
                v-text="form.errors.get('university')">
            </span>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group my-input-item">
            <textarea name="message"
                      placeholder="Имеющийся трудовой опыт/практика (Неофициальное трудоустройство также указывайте)"
                      class="form-control my-input-form my-input-form-grey"
                      v-model="form.experience"></textarea>
          <span class="help is-danger text-danger"
                v-if="form.errors.has('experience')"
                v-text="form.errors.get('experience')">
            </span>
        </div>
      </div>
    </div>

    <input type="text"
           name="checkBot"
           v-model="checkBot"
    >

    <input class="my-button"
           type="submit"
           :disabled="form.errors.any()"
           :value="Lang.get('common.send')">
    <widget-loading v-if="form.loading" color="#03a9f4"></widget-loading>
  </form>
</template>

<script>
import WidgetLoading from '../elements/WidgetLoading';

export default {
  name: "form-vacancy-student",
  components: {
    WidgetLoading,
  },
  props: {
    vacancy: {required: false},
    category: {required: false},
  },
  data() {
    return {
      form: new Form({
        name: '',
        date_born: '',
        city: '',
        experience: '',
        university: '',
        phone: '',
        email: '',
        url: location,
        lang: siteLang,
      }),
      action: '/vacancy-student',
      checkBot: '',
      Lang,
    }
  },
  methods: {
    onSubmit() {
      if(this.checkBot === '') {
        this.form.submit(this.$el.method, this.$el.action).then(res => {
          document.querySelector('#vacancy-form-student').innerHTML = "<span class='success-sent-text text-center'>" + res + "</span>";
        }).catch(error => console.log(error));
      }
    },
  },
  mounted() {
    helpers.setInputMask('mobilephone');
    if(this.vacancy) {
      this.form.vacancy = this.vacancy;
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/forms/FormVacancyStudent.vue